module.exports = __webpack_public_path__ + "img/Group139.54d569d7.png";